import { Box } from 'reflexbox';

import { LearningRouterWithoutSidebar } from '../packages/kakapo-ui-application/pages/learning/pages/LearningRouter';

export default function Learning() {
	return (
		<Box flexGrow={1}>
			<LearningRouterWithoutSidebar />
		</Box>
	);
}
